export function isWindows() {
  return navigator.userAgent.indexOf("Windows") !== -1;
}
